import { createFileRoute } from "@tanstack/react-router";

import { PasswordResetLayout } from "@pages/password-reset/password-reset-layout/password-reset-layout";

export const Route = createFileRoute("/_passwordreset-layout")({
  component: PasswordResetLayout,
});
